import { FormattedMessage } from 'react-intl';
import { Tooltip as AlchemyTooltip } from '@m/alchemy-ui/Tooltip';
import { type TimeLeftResult } from '../IdeaCard.helpers';
import * as Styled from './IdeaCard.styled';

interface TimeLeftCountdownProps {
  readonly timeLeft: TimeLeftResult;
}

const CountdownDetailPopup = ({ timeLeft }: { timeLeft: TimeLeftResult }) => (
  <Styled.CountdownPopup>
    <Styled.CountdownPopupTitle>
      <FormattedMessage id="timeLeft" defaultMessage="Time Left" />
    </Styled.CountdownPopupTitle>
    <Styled.CountdownPopupGrid>
      <Styled.CountdownPopupItem>
        <Styled.CountdownPopupValue>{timeLeft.days}</Styled.CountdownPopupValue>
        <Styled.CountdownPopupLabel>
          <FormattedMessage id="days" defaultMessage="Days" />
        </Styled.CountdownPopupLabel>
      </Styled.CountdownPopupItem>
      <Styled.CountdownPopupItem>
        <Styled.CountdownPopupValue>{timeLeft.hours}</Styled.CountdownPopupValue>
        <Styled.CountdownPopupLabel>
          <FormattedMessage id="hours" defaultMessage="Hours" />
        </Styled.CountdownPopupLabel>
      </Styled.CountdownPopupItem>
      <Styled.CountdownPopupItem>
        <Styled.CountdownPopupValue>{timeLeft.minutes}</Styled.CountdownPopupValue>
        <Styled.CountdownPopupLabel>
          <FormattedMessage id="mins" defaultMessage="Mins" />
        </Styled.CountdownPopupLabel>
      </Styled.CountdownPopupItem>
      <Styled.CountdownPopupItem>
        <Styled.CountdownPopupValue>{timeLeft.seconds}</Styled.CountdownPopupValue>
        <Styled.CountdownPopupLabel>
          <FormattedMessage id="secs" defaultMessage="Secs" />
        </Styled.CountdownPopupLabel>
      </Styled.CountdownPopupItem>
    </Styled.CountdownPopupGrid>
  </Styled.CountdownPopup>
);

export const TimeLeftCountdown = ({ timeLeft }: TimeLeftCountdownProps) => {
  const countdownContent = (
    <Styled.CountdownSection>
      {timeLeft.ongoing ? (
        <>
          <Styled.CountdownValue>{timeLeft.days > 0 ? timeLeft.days : timeLeft.hours}</Styled.CountdownValue>
          <Styled.CountdownLabel>
            {timeLeft.days > 0 ? (
              timeLeft.days === 1 ? (
                <FormattedMessage id="dayLeft" defaultMessage="Day Left" />
              ) : (
                <FormattedMessage id="daysLeft" defaultMessage="Days Left" />
              )
            ) : timeLeft.hours === 1 ? (
              <FormattedMessage id="hrLeft" defaultMessage="Hr Left" />
            ) : (
              <FormattedMessage id="hrsLeft" defaultMessage="Hrs Left" />
            )}
          </Styled.CountdownLabel>
        </>
      ) : (
        <>
          <Styled.CountdownValue>{String(0)}</Styled.CountdownValue>
          <Styled.CountdownLabel>
            <FormattedMessage id="daysLeft" defaultMessage="Days Left" />
          </Styled.CountdownLabel>
        </>
      )}
    </Styled.CountdownSection>
  );

  if (!timeLeft.ongoing) return countdownContent;

  return (
    <AlchemyTooltip
      trigger={countdownContent}
      placement="top"
      contents={<CountdownDetailPopup timeLeft={timeLeft} />}
    />
  );
};
